import Phaser from 'phaser';
import { GAME_IMAGES_KEY } from '../gameData';

export default class TossItem extends Phaser.GameObjects.Image {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    super(scene, 0,0,GAME_IMAGES_KEY, 'Num1');

    this.spriteName = null;
    this.num = null;
    this.vX = null;
    this.vY = null;
    this.curAlpha = null;
    this.vAlpha = null;

    this.tWidth = null;
    this.tHeight = null;
    this.hitw = null;
    this.hith = null;

    this.isGood = true;

    this.isDead = false;
    this.invulnerable = false;
    this.startSpritename = null;

    this.scoreValue = null;

    this.gravity = 0.000045;
    this.vScale = 0.000034;
  }

  getHitBounds () {
    return [this.x - this.hitw, this.y - this.hith, this.x + this.hitw, this.y + this.hith];
  }

  resetForHitSpawn (spritename, hitvalue, isGood, numValue, startX, startY, direction) {
    this.invulnerable = true;
    this.spriteName = spritename;
    this.scoreValue = hitvalue;

    this.scale = 0;
    this.gravity = 0.000295;
    this.isGood = isGood;
    this.curAlpha = 1;
    this.alpha = this.curAlpha;
    this.vAlpha = 0.02;
    this.vScale = 0.02;
    this.isDead = false;

    this.num = numValue;

    this.setFrame(this.spriteName);

    // Set up some boundries for hit collision
    this.tWidth = this.width;
    this.tHeight = this.height;
    this.hitw = this.tWidth / 2;
    this.hith = this.tHeight / 2;

    // positioning and move vars
    const x = startX;
    const y = startY;
    this.x = x;
    this.y = y;

    let min = 274;
    let max = 286;
    if (direction === 0) {
      min = 274;
      max = 286;
    }
    else {
      min = 260;
      max = 269;
    }
    const a = Phaser.Math.Between(min,max);
    this.moveAngleRadians = (Math.PI / 180) * a;

    // var speed = getRandom(26,32);
    let speed = Phaser.Math.Between(38,44);
    speed = speed / 100;
    this.vX = Math.cos(this.moveAngleRadians) * speed;
    this.vY = Math.sin(this.moveAngleRadians) * speed;
  }

  reset (spritename, hitvalue, isGood, numValue, startX, startY) {
    this.scale = 1;
    this.gravity = 0.000045;
    this.isGood = isGood;
    this.curAlpha = 1;
    this.alpha = this.curAlpha;
    this.isDead = false;
    this.scoreValue = hitvalue;
    this.spriteName = spritename;
    this.num = numValue;

    this.setFrame(spritename);

    // Set up some boundries for hit collision
    this.tWidth = this.width;
    this.tHeight = this.height;
    this.hitw = this.tWidth / 2;
    this.hith = this.tHeight / 2;

    // positioning and move vars
    const x = Phaser.Math.Between(40,this.scene.scale.width - 40);
    const y = this.scene.scale.height + 50;
    this.x = x;
    this.y = y;

    let min = 274;
    let max = 286;
    if (x < 395) {
      min = 274;
      max = 286;
    }
    else if (x < 560) {
      min = 260;
      max = 279;
    }
    else {
      min = 260;
      max = 269;
    }
    const a = Phaser.Math.Between(min,max);
    this.moveAngleRadians = (Math.PI / 180) * a;

    let speed = Phaser.Math.Between(21,25);
    speed = speed / 100;
    this.vX = Math.cos(this.moveAngleRadians) * speed;
    this.vY = Math.sin(this.moveAngleRadians) * speed;
  }

  gotHit () {
    this.alpha = 0.25;
    this.isDead = true;
  }

  tick (delta) {
    this.vY += delta * this.gravity;
    this.x += delta * this.vX;
    this.y += delta * this.vY;

    if (this.invulnerable) {
      this.scaleX += this.vScale;
      this.scaleY += this.vScale;

      if (this.scaleX >= 1) {
        this.setFrame(this.spriteName);
        this.invulnerable = false;
        this.scale = 1;
      }
    }
  }
}